import React, { useEffect } from "react";
import * as echarts from "echarts";

interface DepartmentData {
  name: string;
  value: number;
  color: string;
}

interface ChartItem {
  month: string;
  departments: DepartmentData[];
}

interface BarChartProps {
  chartData: ChartItem[];
}

const TeamWellnessBar = ({ chartData }: any) => {
  useEffect(() => {
    const data = chartData || [];

    console.log(data, "TeamWellnessBar");

    // Create a bar chart
    const chart = echarts.init(
      document.getElementById("team-wellness-bar-chart") as HTMLDivElement
    );

    const seriesData = data?.months?.map(
      (_: any, index: any) => data?.data[index] || 0
    );

    const options = {
      grid: {
        left: "0%",
        right: "5%",
        bottom: "2%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: data?.months,
      },
      yAxis: {
        type: "value",
        min: 0, // Set minimum value
        max: 8, // Set maximum value
        // interval: 50,
        //type: "value",
      },
      series: [
        {
          data: seriesData,
          type: "bar",
          barWidth: 15,
          itemStyle: { color: data.color, barBorderRadius: [5, 5, 0, 0] },
        },
      ],
    };

    // Set chart options
    chart.setOption(options);

    // Cleanup on unmount
    return () => {
      chart.dispose();
    };
  }, [chartData]);

  return (
    <div
      id="team-wellness-bar-chart"
      style={{
        width: "100%",
        height: "400px",
        margin: "0 !important",
        cursor: "not-allowed !important",
      }}
    ></div>
  );
};

export default TeamWellnessBar;
